import React from 'react'
import { Route, Switch } from 'react-router-dom'

import CategoryList from './CategoryList'
import CategoryAdd from './CategoryAdd'
import CategoryEdit from './CategoryEdit'

const VehicleCategories = () => ({
    routes: [
        {
            path: '/vehicle-categories',
            render: ({ match }) => (
                <Switch>
                    <Route path={match.url} exact component={CategoryList} />
                    <Route path={`${match.url}/add`} exact component={CategoryAdd} />
                    <Route path={`${match.url}/:categoryId`} exact component={CategoryEdit} />
                </Switch>
            ),
        },
    ],
})

export default VehicleCategories
